import {Axios} from "../../../axiosHelper";
import {AxiosError, AxiosResponse} from "axios";
import {SyslogLogResponse} from "../../data/efeLog";
import {efeLogActions} from "../../slice/efe/efeLogSlice";
import {setSnackbarData} from "../snackbarAction";
import {t} from "i18next";

export const getLogList = (podId: string): any => {
    return async (dispatch: any) => {
        dispatch(efeLogActions.setLoading(true));

        Axios.get("efe/log/" + podId)
            .then((res: AxiosResponse<SyslogLogResponse>) => {
                dispatch(efeLogActions.setLogList(res.data.logs));
                dispatch(efeLogActions.setLogCount(res.data.logCount))
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(efeLogActions.setError(resp));
                    }
                }
            });
    };
};

export const downloadLogList = (podId: string): any => {
    return async (dispatch: any) => {
        Axios.get("efe/log/" + podId + "/csv-download", { responseType: 'blob' })
            .then((res) => {
                const href = URL.createObjectURL(res.data);
                const link = document.createElement('a');
                link.href = href;
                const contentDisposition = res.headers?.["content-disposition"] as string | undefined;
                const fallbackFileName = `${podId}_syslog.csv`;
                const match = contentDisposition?.match(/filename="?([^"]+)"?/);
                const fileName = match?.[1] ?? fallbackFileName;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                URL.revokeObjectURL(href);
                dispatch(setSnackbarData({
                    status: 'success',
                    text: t('actionSuccess')
                }))
            })
            .catch((err) => {
                dispatch(setSnackbarData({
                    status: 'danger',
                    text: t('actionFailed')
                }))
            })
    };
};
